import { IOrderBody, IPaymentMethod, IPreOrderBody, IPreOrderResponse } from "../models/IOrder";
import { configWithUserToken } from "./config";

export const getPaymentMethods = (restaurantId: string) => {
  return configWithUserToken.get<IPaymentMethod[]>(`PaymentMethod/restaurant/${restaurantId}`);
};

export const createPreOrder = (body: IPreOrderBody) => {
  return configWithUserToken.post<IPreOrderResponse>(`Order/PreOrder`, body, {
    headers: { "Idempotency-Key": crypto.randomUUID() },
  });
};

export const createOrder = (body: IOrderBody) => {
  return configWithUserToken.post(`Order`, body, {
    headers: { "Idempotency-Key": crypto.randomUUID() },
  });
};
